import { lazy } from 'react'

const Test = lazy(() =>
import('../../views/dashboard/test')
)

const WithdrawRoutes = [

  {
    path: '/concession/withdrawal',
    element: <Test />
    // meta:{

    // }
  }
]

export default WithdrawRoutes
